import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setCharacters,
  setFamilies,
  selectCharactersByProject,
  selectFamiliesByProject,
} from '../../../../../features/characters/charactersSlice';
import characterService from '../../../../../utils/apiRequests/characterService';

const normalize = (item) => ({
  ...item,
  id: item.id || item._id?.toString() || item._id,
  projectId: item.projectId?.toString() || item.projectId,
  familyId: item.familyId?.toString() || item.familyId || null,
});

/**
 * Reads project characters/families from the store, fetching them once if absent.
 */
const useProjectCharacters = (projectId) => {
  const dispatch = useDispatch();
  const characters = useSelector(selectCharactersByProject(projectId));
  const families = useSelector(selectFamiliesByProject(projectId));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!projectId || characters.length > 0) return;
      setLoading(true);
      const [charResponse, familyResponse] = await Promise.all([
        characterService.getCharacters(projectId, { useCache: false }),
        characterService.getFamilies(projectId, { useCache: false }),
      ]);
      if (cancelled) return;
      if (!charResponse.error) {
        const fetched = (charResponse.data?.characters || []).map(normalize);
        if (fetched.length > 0) {
          dispatch(setCharacters(fetched));
        }
      }
      if (!familyResponse.error) {
        const fetched = (familyResponse.data?.families || []).map(normalize);
        if (fetched.length > 0) {
          dispatch(setFamilies(fetched));
        }
      }
      setLoading(false);
    };
    load();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId, dispatch]);

  return { characters, families, loading };
};

export default useProjectCharacters;
